import { User, FileText, ClipboardCheck, RefreshCw, ArrowRight } from "lucide-react"
import { useState } from "react"
import { ResourceGateModal, checkResourceAccess } from "./resource-gate-modal"

const RESOURCE_URL = "https://www.npmjs.com/package/n8n-nodes-bridgegate"

const capabilities = [
  {
    icon: User,
    title: "Patient Demographics",
    description: "Fetch patient demographics via MRN with seamless integration to your existing workflows.",
    color: "bg-[#faf5f7]",
  },
  {
    icon: FileText,
    title: "Encounter Metadata",
    description: "Pull clinical encounter metadata and provider details directly into your n8n automations.",
    color: "bg-[#faf5f7]",
  },
  {
    icon: ClipboardCheck,
    title: "Clinical Documents",
    description: "Retrieve clinical documents (CCDs, discharge summaries) automatically without custom code.",
    color: "bg-[#faf5f7]",
  },
  {
    icon: RefreshCw,
    title: "Data Transformation",
    description: "Validate and transform data for any destination with built-in formatting capabilities.",
    color: "bg-[#faf5f7]",
  },
]

export function CapabilitiesSection() {
  const [resourceModalOpen, setResourceModalOpen] = useState(false)

  // Check if user already has access before opening modal
  const handleResourceAccess = () => {
    if (checkResourceAccess()) {
      // User already has access, open resource directly
      window.open(RESOURCE_URL, '_blank')
    } else {
      // Show the gate modal
      setResourceModalOpen(true)
    }
  }

  return (
    <>
      <section id="bridgegate-n8n" className="py-20 lg:py-24 bg-white">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-4">
            <p className="text-[#9e3667] font-semibold text-sm uppercase tracking-wide">BridgeGate Capabilities</p>
          </div>
          <div className="text-center mb-14">
            <h2 className="text-3xl font-bold tracking-tight text-[#2d2d3a] sm:text-4xl">
              What Can You Do{" "}
              <span className="bg-[linear-gradient(135deg,#a63083,#bf406a)] bg-clip-text text-transparent">With It?</span>
            </h2>
            <p className="mt-4 text-lg text-[#6b6b7b] max-w-2xl mx-auto">
              The BridgeGate node for n8n unlocks powerful healthcare data integration capabilities
            </p>
          </div>

          <div className="grid gap-6 sm:grid-cols-2">
            {capabilities.map((capability) => (
              <div 
                key={capability.title} 
                className="group relative bg-white rounded-xl p-6 border border-[#e8e8ec] hover:border-[#9e3667]/40 hover:shadow-lg transition-all"
              >
                <div className="flex items-start gap-4">
                  <div className={`flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-lg ${capability.color}`}>
                    <capability.icon className="h-6 w-6 text-[#9e3667]" />
                  </div>
                  <div className="flex-1">
                    <h3 className="text-lg font-semibold text-[#2d2d3a] mb-2">{capability.title}</h3>
                    <p className="text-sm text-[#6b6b7b] leading-relaxed mb-3">
                      {capability.description}
                    </p>
                    <button 
                      onClick={handleResourceAccess}
                      className="inline-flex items-center gap-1 text-sm font-medium text-[#9e3667] hover:text-[#843054] transition-colors"
                    >
                      Learn More <ArrowRight className="h-3 w-3" />
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>

          <div className="mt-12 text-center">
            <button 
              onClick={handleResourceAccess}
              className="inline-flex items-center gap-2 text-[#9e3667] hover:text-[#843054] font-medium transition-colors"
            >
              Explore the BridgeGate n8n Node
              <ArrowRight className="h-4 w-4" />
            </button>
          </div>
        </div>
      </section>

      <ResourceGateModal 
        open={resourceModalOpen} 
        onOpenChange={setResourceModalOpen}
        resourceUrl={RESOURCE_URL}
        resourceName="n8n Node Documentation"
      />
    </>
  )
}
